import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { LG_RENOWNED_LOGO_PATH, SM_RENOWNED_LOGO_PATH } from '@rma/dashboard/layout/public/util-layout';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-navigation-header',
  templateUrl: './navigation-header.component.html',
  styleUrls: ['./navigation-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, MatToolbarModule, MatButtonModule, StaticImageUrlPipe, RmaIconComponent, RouterModule],
})
export class NavigationHeaderComponent implements OnInit {
  @Input() public label?: string;
  @Input() public redirectUrl?: string | null;
  @Input() public showBackLink = true;

  @Output() public backClick = new EventEmitter();

  protected readonly lgRenownedLogoPath = LG_RENOWNED_LOGO_PATH;
  protected readonly smRenownedLogoPath = SM_RENOWNED_LOGO_PATH;

  public cancelUrl?: string;
  public behaviourType?: 'button' | 'link';

  ngOnInit(): void {
    this.behaviourType = this.backClick.observers.length > 0 ? 'button' : 'link';
    this.cancelUrl = this.redirectUrl ?? '/';
  }
}
